module.exports = __webpack_public_path__ + "assets/media/w1.615cfa81.mp4";